export const API_URL = "http://api.peuplingues.fr";
export const PICTURE_URL = "http://pictures.peuplingues.fr";
